import React from "react";
import DashboardContextProvider from "./dashboardContextProvider";
import {Dashboard} from "./dashboard";
import config from "../../config/config";


export const DashboardPage = () => {
    const showDashboard = config.showDashboard ?? false;

    return (
        <>
            {showDashboard &&
                <DashboardContextProvider>
                    <Dashboard/>
                </DashboardContextProvider>
            }
        </>
    );
}
